/* this file is transformed by vux-loader */
/* eslint-disable */
export default {
  more: '更多',
  ask_doctor: '问医生',
  fzkf: '复诊开方',
  twzx: '图文咨询',
  spzx: '视频咨询',
  goodat: '擅长',
  wzl: '问诊量',
  online: '在线',
  offline: '离线',
  hfl: '回复率',
  cfw: '次服务',
  gfans: '个粉丝',
  main_intro: '简介',
  go_appointment: '去预约',
  tjyf: '添加孕妇',
  title: '标题',
  main_title: '主标题',
  nav: '导航',
  nickname: '昵称',
  yrz: '已认证',
  wsm: '未实名',
  fn_title: '功能标题',
  test_name: '陈淼',
  test_post_name: '医师',
  test_advantageDesc: '这里是擅长文案的占位符',
  test_hospital: '人民医院',
  test_dept: '肾内科一区1号室'
};